export interface GetLendUserByIdRequest {
  id?: string
  felicaId?: string
  readingInside: boolean
}

const ReadingInside = {
  Lend: '0',
  ReadingInside: '1'
}
type ReadingInside = typeof ReadingInside[keyof typeof ReadingInside]

export function GetLendUserByIdRequestToJSON(
  value: GetLendUserByIdRequest
): any {
  return {
    id: value.id || undefined,
    felica_id: value.felicaId || undefined,
    reading_inside: value.readingInside
      ? ReadingInside.ReadingInside
      : ReadingInside.Lend
  }
}
